import apiFetch from './api_fetch';

export default async function makeEnrollment(clientUuid, studentUuid, itemUuid) {
  return apiFetch('/v1/purchases?skip_payment=true', {
    method: 'POST',
    body: JSON.stringify({
      customer_id: clientUuid,
      customer_type: 'client',
      payment: {},
      items: [
        {
          duration_seconds: 2700,
          item_id: itemUuid
        }
      ],
      student: {
        id: studentUuid
      }
    })
  });
}
